import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FileInteractor} from './file.interactor';

interface SupportedFormat {
    size?: { max?: number, min?: number };
    extensions?: string;
}

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html'
})
export class FileUploadComponent {
    constructor(private fileInteractor: FileInteractor) {

    }

    @Input()
    placeHolder: string;

    @Input()
    header: string;

    @Input()
    supportedFormat?: SupportedFormat;

    @Output()
    uploadedFileId = new EventEmitter();

    public async upload(files: any) {
        await this.fileInteractor.upload(files);
    }
}


